<script>
    export default {
        props: {
            close: {
                type: Function,
                default: () => {
                },
            },
            title: String,
            visible: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                window: null,
            }
        },
        methods: {},
        computed: {},
        watch: {},
        components: {},
        mounted() {
            this.window = this.$window({
                title: this.title,
                slots: this.$slots.default,
                close: this.close,
                visible: this.visible,
            });
        },
        updated() {
            this.window.slot = this.$slots.default;
            this.window.title = this.title;
            this.window.close = this.close;
            this.window.visible = this.visible;
        },
        destroyed() {
            this.window.$destroy();
        },
    }
</script>
<template>
    <div></div>
</template>
<style lang="scss">
</style>
